import React from "react";
import { Dialog } from "@mui/material";
import infoCorner from "../../../../images/infocorner.svg";
import forwardGuy from "../../../../images/forwardguy.svg";
import times from "../../../../images/icons/times2.svg";
import StyledButton from "../../../../shared/components/styledButton/styledButton";
import i18n from "../../../../utils/i18n";

const InactiveProviderDialog = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClick={onClose}
      PaperProps={{
        className: "dlpForwardDialogPaper",
      }}
    >
      <div className="dlpForwardDialog">
        <div className="dlpForwardHeader">
          <img className="dlpinfoCorner" alt="Info Corner" src={infoCorner} />
          <span
            className="dlpBold16"
            style={{ marginLeft: "12px", marginRight: "auto" }}
          >
            {i18n.t("providerdashboard.providerunavailable")}
          </span>
          <span
            onClick={onClose}
            className="dlpBold16"
            style={{ padding: "0 16px", cursor: "pointer" }}
          >
            <img src={times} alt="closing button" />
          </span>
        </div>
        <div className="dlpForwardContent">
          <p className="dlpText14">
            {i18n.t("providerdashboard.providerunavailabletext")}
          </p>

          <img className="dlpForwardGuy" alt="Forward Guy" src={forwardGuy} />
        </div>

        <div className="dlpDividerProviderCard"></div>

        <div className="dlpBtnFooter">
          <p
            style={{ cursor: "pointer", marginLeft: "28px" }}
            className="dlpText14"
            onClick={onClose}
          >
            {i18n.t("providerdashboard.undo")}
          </p>
          <StyledButton
            onClick={(e) => {
              e.stopPropagation();

              // const selectedProvider = localStorage.getItem('selectedSP');
              // console.log('Selected provider from localStorage:', selectedProvider);

              localStorage.removeItem("selectedSP");
              // console.log('Cleared selectedSP from localStorage');

              onClose();
              window.location.href = `${
                process.env.REACT_APP_FRONT_END_URL ||
                "https://dashboard-hu.bookkeepie.com"
              }/company/request/1`;
            }}
            color={"NewReqBtn"}
          >
            {i18n.t("general.forwardbutton")}
          </StyledButton>
        </div>
      </div>
    </Dialog>
  );
};

export default InactiveProviderDialog;
